import React, { Component } from "react";
import FieldError from "./FieldError";
import {cx} from "../../lib/ClassSet";
import MessageBus from "../../lib/MessageBus";
import format from "date-fns/format";
import "./DateInputField.css";

const noOp = () => null;

class DateInputField extends Component {

  componentDidMount() {
    this.subscription = MessageBus.subscribe("DatePicker", this.props.input.name, this.handleDatePicker.bind(this));
  }

  componentWillUnmount() {
    MessageBus.unsubscribe(this.subscription);
    this.subscription = null;
  }

  render() {
    const {serverError, label, active, input: {value, onChange}, meta: {touched, error}} = this.props;    
    let changeHandler = active ? onChange : noOp;
    let classes = cx({
      "DateInput": true,
      "s-inactive": !active
    });

    const formattedDate = value
      ? format(value, this.props.dateFormat)
      : "Pick a Date";

    return (
      <tr className="DateInputField field">
        <th>{label}</th>
        <td>
          <div className={classes} onClick={this.handleClick.bind(this)}>
            <input type="text" value={value} onChange={changeHandler} disabled/>
            <div className="text">{formattedDate}</div>
          </div>          
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </td>
      </tr>
    )
  }

  handleDatePicker(data, envelope) {
    let date = format(data, "YYYY-MM-DD");
    this.props.input.onChange(date);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.showDatePicker(this.props.input.name, this.props.input.value);
  }
}

DateInputField.defaultProps = {
  active: true,
  dateFormat: "YYYY-MM-DD"
}

export default DateInputField;